// extracted by mini-css-extract-plugin
export default {"element":"Opintopolkuun_element__u+dum"};